<template>
  <div v-if="team" ref="root" class="v5-pop-wrap">
    <button
      class="v5-team"
      type="button"
      :aria-label="t('v5.shell.switch_team', { name: team.name })"
      :aria-expanded="String(open)"
      aria-controls="v5-teams"
      @click="toggle"
    >
      <img v-if="team.logo" class="v5-avatar" :src="team.logo" alt="">
      <span v-else class="v5-avatar" aria-hidden="true">{{ initials(team.name) }}</span>
      <span class="v5-team__name">{{ team.name }}</span>
      <small>{{ tier(team.access_level) }}</small>
      <ChevronUpDownIcon class="i" aria-hidden="true" />
    </button>
    <ul v-if="open" id="v5-teams" class="v5-pop v5-pop--up v5-pop--menu">
      <li v-for="x in teams" :key="x.id">
        <button
          class="v5-nav"
          type="button"
          :aria-current="x.id === team.id ? 'true' : undefined"
          @click="pick(x)"
        >
          <img v-if="x.logo" class="v5-avatar" :src="x.logo" alt="">
          <span v-else class="v5-avatar" aria-hidden="true">{{ initials(x.name) }}</span>
          <span class="v5-team__name">{{ x.name }}</span>
          <span class="v5-chip">{{ tier(x.access_level) }}</span>
          <CheckIcon v-if="x.id === team.id" class="i v5-good" aria-hidden="true" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/24/outline';
import usePopover from './usePopover';

// The classic sidebar's team menu: picking a team stores it and reloads (useAppShell.switchTeam)
const props = defineProps({
  team: { type: Object, default: null },
  teams: { type: Array, default: () => [] },
});
const emit = defineEmits(['switch']);
const { t } = useI18n();
const { open, root, toggle } = usePopover();

// Public tier names (Player is Core, Competitor is Prime); the keys follow access_level
const TIERS = {
  1: 'core', 2: 'prime', 3: 'team', 4: 'pro', 5: 'admin',
};
const tier = (level) => t(`v5.shell.tier.${TIERS[level] || 'free'}`);
const initials = (name = '') => name.split(/\s+/).map((w) => w[0]).join('')
  .slice(0, 2)
  .toUpperCase();

function pick(x) {
  if (x.id === props.team.id) open.value = false;
  else emit('switch', x);
}
</script>
